import { BookingGenerationJob } from '../../../types';

import { apiRequest } from './client';

// Get booking generation job by ID
export const getBookingGenerationJob = async (
  jobId: string,
  token: string
): Promise<BookingGenerationJob> => {
  return apiRequest<BookingGenerationJob>({
    endpoint: `/booking-generations/${jobId}`,
    method: 'GET',
    token,
  });
};

// Queue booking generation for a receipt in ready status
export const generateBookingFromReceipt = async (
  receiptId: string,
  token: string
): Promise<BookingGenerationJob> => {
  return apiRequest<BookingGenerationJob>({
    endpoint: `/booking-generations/from-receipt/${receiptId}`,
    method: 'POST',
    token,
  });
};

// Retry booking generation for a receipt
export const retryBookingGeneration = async (
  receiptId: string,
  token: string
): Promise<BookingGenerationJob> => {
  return apiRequest<BookingGenerationJob>({
    endpoint: '/booking-generations/retry',
    method: 'POST',
    token,
    body: { receiptId },
  });
};
